module.exports = __webpack_public_path__ + "img/calcul litteral.ec8c6a7b.png";